import { Component, Input, ViewEncapsulation } from '@angular/core';
import { BaggageInfo, FavoriteCardTypeEnum, UserFavoriteCardDataFlights } from '../../../../user-favorite-data.model';

@Component({
  selector: 'favorite-card-flight-itinerary',
  template: `
    <div class="container {{cardType}}">
      <ng-container *ngFor="let itinerary of data.itineraries">
        <div class="route">
          <div class="destination" [ngClass]="{'-flex-column': data.itineraries.length > 2}">
            <div class="flight-type">
              <i class="icon eva-3-icon-airplane-{{ itinerary.flight_type === 'OUTBOUND' ? 'going' : 'return' }}"></i>
              <span class="route-text">{{ itinerary.text.toUpperCase() }}</span>
            </div>
            <span class="route-from-to">{{ itinerary.from }} - {{ itinerary.to }}</span>
          </div>
          <div class="date">{{ itinerary.check_in_date }}</div>
          <div *ngIf="itinerary.check_in_time || itinerary.scale_text" class="hour-scale">
            <span *ngIf="itinerary.check_in_time" class="check-in-time">{{ itinerary.check_in_time }} - </span>
            <span [ngClass]="{ '-success-color': itinerary.stops_quantity === 0 }">{{ itinerary.scale_text }}</span>
          </div>
        </div>
      </ng-container>

      <div *ngIf="baggage"  class="info">
        <baggages-wrapper
          class="baggages-wrapper"
          [baggageInfo]="baggage"
          [locale]="locale"
          [flow]="flow"
          [tooltipPosition]="'-'+ (position === 0 ? 'right' : 'left') + '-inline'"
          [disableTooltip]="cardType === FavoriteCardTypeEnum.REDUCED"
        ></baggages-wrapper>
        <span *ngIf="data.stay_text" class="stay">{{ data.stay_text }}</span>
      </div>
    </div>
  `,
  styleUrls: ['./favorite-card-itinerary.component.scss'],
})
export class FavoriteCardFlightItineraryComponent {
  @Input() data: UserFavoriteCardDataFlights;
  @Input() baggage: BaggageInfo;
  @Input() locale: string;
  @Input() flow: string;
  @Input() cardType: FavoriteCardTypeEnum;
  @Input() position: number;

  FavoriteCardTypeEnum = FavoriteCardTypeEnum;

  constructor() { }
}
